export interface QuestionnaireItem {
  key: string;
  title: string;
}

/** Default matnasnet questionnaire — copy ComponentsModule + this file into other apps */
export const DEFAULT_APP_QUESTIONNAIRE_QUESTIONS: QuestionnaireItem[] = [
  {
    key: 'dailyProductivity',
    title: 'עד כמה האפליקציה עוזרת לך לבצע את העבודה היומיומית?',
  },
  {
    key: 'uiIntuitive',
    title: 'עד כמה הממשק נוח ואינטואיטיבי?',
  },
  {
    key: 'stabilitySpeed',
    title: 'עד כמה האפליקציה יציבה ומגיבה במהירות?',
  },
  {
    key: 'functionalityNeeds',
    title: 'עד כמה הפונקציונליות הקיימת מספקת את הצרכים שלך?',
  },
  {
    key: 'recommendToPeer',
    title: 'עד כמה סביר שתמליץ על האפליקציה לעמית?',
  },
];

export const DEFAULT_OPEN_FEEDBACK = {
  title: 'מה השינוי המשמעותי ביותר שהיית רוצה לראות באפליקציה?',
  placeholder: 'כתבו כאן את ההצעה שלכם (אופציונלי)',
};



// WEBPACK FOOTER //
// ./src/components/app-questionnaire/app-questionnaire.model.ts